import { memo, useLayoutEffect } from 'react'

import {
  useSetPrevLocation,
  useSetCurrentLocation,
  useCurrentLocation
} from '../../model/router.hooks'
import { useNavigate } from '@tanstack/react-router'

export const Redicrector = memo(() => {
  const redirect = useNavigate()
  const setCurrentPath = useSetPrevLocation()
  const setRedirectPath = useSetCurrentLocation()
  const current = useCurrentLocation()
  useLayoutEffect(() => {
    if (current) {
      redirect({ to: current, replace: true })
      setRedirectPath(null)
      setCurrentPath(null)
    }
  }, [current, redirect, setCurrentPath, setRedirectPath])

  return null
})
